<template>
    <div>
        <material-card
            color="green"
            class="notes-card"
            v-bind:class="{ 'hide-header elevation-0': hideHeader }"
        >
            <v-flex slot="header">
                <v-layout row>
                    <span
                        class="title font-weight-light mb-2"
                        style="align-self: center"
                        >Notes ({{ notes.length }})</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="toggleExpansion"
                        flat
                        icon
                        class="ma-0"
                        color="#fff"
                    >
                        <v-icon>{{
                            expanded
                                ? "mdi-minus-circle-outline"
                                : "mdi-plus-circle-outline"
                        }}</v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
            <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>

            <div v-if="!loading && expanded">
                <div v-if="notes.length">
                    <div v-for="(note, index) in notes">
                        <div v-if="!note.editing">
                            <v-layout row>
                                <v-layout
                                    row
                                    wrap
                                    class="mt-3 mx-3"
                                    v-bind:class="{ 'mt-0 mx-0': hideHeader }"
                                >
                                    <div class="font-weight-light mr-2">
                                        {{ note.date | time }}
                                    </div>
                                    <div class="font-weight-regular mr-2">
                                        {{ note.byUser }}
                                    </div>

                                    <div class="font-weight-light">
                                        {{ note.note1 }}
                                    </div>
                                </v-layout>
                                <v-btn
                                    @click="() => openDeleteNoteDialog(note)"
                                    flat
                                    icon
                                    class="text-xs-right mb-0 mt-1 mr-1"
                                    color="#999"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>

                                <v-btn
                                    @click="() => editNote(note)"
                                    flat
                                    icon
                                    class="text-xs-right mb-0 mt-1 mr-2"
                                    color="#999"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </v-layout>
                            <div
                                class="font-weight-light mx-1"
                                v-if="note.requestType"
                                style="margin-left: 6px;"
                            >
                                <span class="font-weight-regular mr-1"
                                    >Request Type:</span
                                >{{ note.requestType }}
                            </div>
                            <div v-if="note.additionalFields" class="mx-1 mt-1">
                                <div
                                    class="font-weight-light"
                                    v-if="note.additionalFields.offered"
                                >
                                    <span class="font-weight-regular mr-1"
                                        >Offer:</span
                                    >{{ note.additionalFields.offered }}
                                </div>
                                <div
                                    class="font-weight-light"
                                    v-if="note.additionalFields.counterOffer"
                                >
                                    <span class="font-weight-regular mr-1"
                                        >Counter Offer:</span
                                    >{{ note.additionalFields.counterOffer }}
                                </div>
                                <div
                                    class="font-weight-light"
                                    v-if="note.additionalFields.hanhulahNotes"
                                >
                                    <span class="font-weight-regular mr-1"
                                        >Hanhulah Notes:</span
                                    >{{ note.additionalFields.hanhulahNotes }}
                                </div>
                            </div>
                            <div
                                class="font-weight-light mx-1"
                                v-if="note.followUpDate"
                            >
                                <span class="font-weight-medium mr-2"
                                    >Follow Up Date:</span
                                >{{ note.followUpDate | date }}
                            </div>
                            <div
                                class="font-weight-light mx-1"
                                v-if="note.followUpDate"
                            >
                                <span class="font-weight-medium mr-2"
                                    >Status:</span
                                >{{ note.status }}
                            </div>
                        </div>

                        <div class="mt-2" v-if="note.editing">
                            <v-textarea
                                outline
                                class="mb-2"
                                hide-details
                                label="Note"
                                v-model="note.note1"
                            ></v-textarea>
                            <v-layout
                                row
                                justify-start
                                align-start
                                class="ml-0"
                            >
                                <v-checkbox
                                    style="min-width: 110px; max-width: 110px;"
                                    label="Follow Up"
                                    class="pt-3 pb-2 my-0 mr-2"
                                    color="success"
                                    v-model="note.shouldFollowUp"
                                    hide-details
                                ></v-checkbox>
                                <v-menu
                                    class="mr-5"
                                    v-if="note.shouldFollowUp"
                                    v-model="note.datePickerMenu"
                                    :close-on-content-click="false"
                                    offset-y
                                    full-width
                                    prepend-icon="mdi-currency-usd"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="note.followUpDate"
                                            :value="note.followUpDate"
                                            label="Follow Up Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="note.followUpDate"
                                    ></v-date-picker>
                                </v-menu>

                                <v-select
                                    v-if="showRequestType"
                                    :items="requestTypes"
                                    class="width-200 mr-3"
                                    label="Request Type"
                                    v-model="note.requestType"
                                    hide-details
                                    clearable
                                ></v-select>
                                <v-select
                                    v-if="showCommunicationType"
                                    :items="communicationTypes"
                                    class="width-250 pl-2"
                                    label="Communication Type"
                                    v-model="note.communicationType"
                                    hide-details
                                ></v-select>
                            </v-layout>
                            <v-select
                                v-if="note.shouldFollowUp"
                                :items="statuses"
                                class="pt-0"
                                label="Status"
                                v-model="note.status"
                                hide-details
                            ></v-select>
                            <div
                                class="ml-0 mt-3"
                                v-if="
                                    showRequestType &&
                                        note.requestType == 'Price Discount'
                                "
                            >
                                <v-text-field
                                    label="Offered"
                                    v-model="note.additionalFields.offered"
                                    type="number"
                                ></v-text-field>
                                <v-text-field
                                    label="Counter Offer"
                                    v-model="note.additionalFields.counterOffer"
                                    type="number"
                                ></v-text-field>
                                <v-text-field
                                    label="Hanhulah Notes"
                                    v-model="
                                        note.additionalFields.hanhulahNotes
                                    "
                                ></v-text-field>
                            </div>

                            <v-layout row class="mr-0 pt-2 pb-3">
                                <v-spacer></v-spacer>
                                <a
                                    href=""
                                    v-on:click.prevent="rollback(note)"
                                    style="color: #999"
                                    class="note-button-link-text mr-2 pr-1"
                                    >Cancel</a
                                >
                                <a
                                    href=""
                                    :disabled="processing"
                                    v-on:click.prevent="save(note)"
                                    class="note-button-link-text"
                                    >Save</a
                                >
                            </v-layout>
                        </div>

                        <v-divider class="mt-3 mb-2"></v-divider>
                    </div>
                </div>
                <div class="mt-2" v-bind:class="{ 'mt-3': notes.length }">
                    <v-textarea
                        outline
                        class="mb-2"
                        hide-details
                        label="Note"
                        v-model="newNote.note1"
                    ></v-textarea>
                    <v-layout row justify-start align-start class="ml-0">
                        <v-checkbox
                            style="max-width: 110px;"
                            label="Follow Up"
                            class="pt-3 pb-2 my-0 mr-2"
                            color="success"
                            v-model="newNote.shouldFollowUp"
                            hide-details
                            @change="shouldFollowUpChanged($event, newNote)"
                        ></v-checkbox>
                        <v-menu
                            class="mr-3"
                            v-if="newNote.shouldFollowUp"
                            v-model="newNote.datePickerMenu"
                            :close-on-content-click="false"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="newNote.followUpDate"
                                    :value="newNote.followUpDate"
                                    label="Follow Up Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    class="width-150"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="newNote.followUpDate"
                            ></v-date-picker>
                        </v-menu>
                        <v-select
                            v-if="showCommunicationType"
                            :items="communicationTypes"
                            class="width-250 mr-3"
                            label="Communication Type"
                            v-model="newNote.communicationType"
                            hide-details
                        ></v-select>
                        <v-select
                            v-if="showRequestType"
                            :items="requestTypes"
                            class="width-200 mr-3"
                            label="Request Type"
                            v-model="newNote.requestType"
                            hide-details
                            clearable
                        ></v-select>
                        <v-select
                            v-if="
                                newNote.shouldFollowUp && showCommunicationType
                            "
                            :items="statuses"
                            label="Status"
                            v-model="newNote.status"
                            hide-details
                        ></v-select>
                        <v-spacer></v-spacer>
                    </v-layout>
                    <v-select
                        v-if="newNote.shouldFollowUp && !showCommunicationType"
                        :items="statuses"
                        class=""
                        label="Status"
                        v-model="newNote.status"
                        hide-details
                    ></v-select>
                    <div
                        class="ml-0 mt-3"
                        v-if="
                            showRequestType &&
                                newNote.requestType == 'Price Discount'
                        "
                    >
                        <v-text-field
                            label="Offered"
                            v-model="newNote.additionalFields.offered"
                            type="number"
                        ></v-text-field>
                        <v-text-field
                            label="Counter Offer"
                            v-model="newNote.additionalFields.counterOffer"
                            type="number"
                        ></v-text-field>
                        <v-text-field
                            label="Hanhulah Notes"
                            v-model="newNote.additionalFields.hanhulahNotes"
                        ></v-text-field>
                    </div>
                    <v-layout row class="mr-0 pt-2 pb-3">
                        <v-spacer></v-spacer>
                        <!-- <a
                            href=""
                            @click="rollback(newNote)"
                            style="color: #999"
                            class="note-button-link-text mr-2 pr-1"
                            >Cancel</a
                        > -->
                        <a
                            href=""
                            :disabled="processing"
                            v-on:click.prevent="save(newNote)"
                            class="note-button-link-text"
                            >Save</a
                        >
                    </v-layout>
                </div>
            </div>
        </material-card>
        <v-dialog
            persistent
            scrollable
            v-model="deleteNoteDialog"
            max-width="400"
        >
            <v-card>
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-0 pt-0">
                    This will delete the note:
                    <br />
                    {{ noteToDelete.note1 }}
                </v-card-text>
                <v-card-actions class="pb-3 mb-1">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="deleteNoteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="deleteNote">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";

export default {
    props: {
        loadUrl: String,
        accountID: String,
        studentID: String,
        typeID: String,
        type: String,
        isExpanded: Boolean,
        hideHeader: Boolean,
        showCommunicationType: Boolean,
        showRequestType: Boolean,
    },
    data: () => ({
        notes: [],
        loading: true,
        processing: false,

        deleteNoteDialog: false,
        noteToDelete: "",
        statuses: ["Open", "Closed"],
        requestTypes: ["Price Discount"],
        communicationTypes: [],

        expanded: false,

        newNote: {
            note1: "",
            datePickerMenu: false,
            shouldFollowUp: false,
            status: "",
            communicationType: "",
            followUpDate: toISOLocal(new Date(moment())).substr(0, 10),
            requestType: "",

            additionalFields: {
                offered: "",
                counterOffer: "",
                hanhulahNotes: "",
            },
        },
    }),
    async created() {
        if (this.isExpanded) {
            this.expanded = true;
        }

        this.load(this.loadUrl);
        this.loadCommunicationTypeList();
        this.loadRequestTypeList();
    },
    watch: {
        accountID(newValue) {
            if (newValue) {
                this.load();
            }
        },
    },
    methods: {
        async load(url = null) {
            url = url ? url : this.loadUrl;

            if (!url) {
                url =
                    "api/note/getNotes?type=" +
                    this.type +
                    "&accountID=" +
                    this.accountID +
                    "&typeID=" +
                    this.typeID;
            }

            const notes = await this.$http.get(url);

            if (this.showRequestType) {
                const response = await this.$http.post(
                    "api/note/getAdditionalFields",
                    notes.map((n) => n.id),
                );

                notes.forEach((note) => {
                    const fields = response.find((r) => r.noteID == note.id);

                    if (fields) {
                        note.additionalFields = fields;
                    }
                });
            }

            this.notes = notes.map((note) => {
                note.editing = false;
                note.shouldFollowUp = note.followUpDate ? true : false;
                note.followUpDate = note.followUpDate
                    ? new Date(moment(note.followUpDate))
                          .toISOString()
                          .substr(0, 10)
                    : "";

                return note;
            });

            this.loading = false;
        },
        async loadCommunicationTypeList() {
            this.communicationTypes = (await loadOptions(
                "NoteCommunicationType",
            )).map((c) => c.value);
        },
        async loadRequestTypeList() {
            this.requestTypes = (await loadOptions("NoteRequestType")).map(
                (c) => c.value,
            );
        },
        getNotes() {
            return this.notes;
        },
        toggleExpansion() {
            this.expanded = !this.expanded;
        },
        shouldFollowUpChanged(value, note) {
            if (value) {
                note.status = "Open";
            } else {
                note.status = "";
            }
        },
        editNote(note) {
            note.original = note.note1;
            note.originalFollowUpDate = note.followUpDate;
            note.originalShouldFollowUp = note.shouldFollowUp;
            note.originalStatus = note.status;
            note.originalCommunicationType = note.communicationType;
            note.originalRequestType = note.requestType;
            note.followUpDate = note.followUpDate
                ? toISOLocal(new Date(moment(note.followUpDate))).substr(0, 10)
                : toISOLocal(new Date(moment())).substr(0, 10);
            note.editing = true;
        },
        rollback(note) {
            note.note1 = note.original;
            note.status = note.originalStatus;
            note.communicationType = note.originalCommunicationType;
            note.followUpDate = note.originalFollowUpDate;
            note.shouldFollowUp = note.originalShouldFollowUp;
            note.requestType = note.originalRequestType;
            note.editing = false;
        },
        disableNote(note) {
            return !note.note1;
        },
        async save(note) {
            try {
                if (!note.note1) {
                    return this.$notify({
                        text: "Note is empty",
                        group: "notification",
                        type: "error",
                    });
                }

                const today = moment().format("YYYY-MM-DD HH:mm:ss");
                this.processing = true;

                await this.$http.post("api/note/save", {
                    note: {
                        id: note.id || 0,
                        type: this.type,
                        date: today,
                        note1: note.note1,
                        status: note.shouldFollowUp ? note.status : null,
                        communicationType: note.communicationType,
                        requestType: note.requestType,
                        followUpDate: note.shouldFollowUp
                            ? moment(note.followUpDate).format("YYYY-MM-DD")
                            : null,
                        byUser:
                            note.byUser ||
                            this.$store.state.authentication.user,
                        accountID: this.accountID,
                        studentID: this.studentID,
                        typeID: this.typeID,
                        lastUpdated: !note.id ? null : today,
                        updatedBy: !note.id
                            ? null
                            : this.$store.state.authentication.user,
                    },
                    additionalNoteFields: {
                        hanhulahNotes: note.additionalFields.hanhulahNotes,
                        offered: note.additionalFields.offered,
                        counterOffer: note.additionalFields.counterOffer,
                    },
                });

                this.newNote.note1 = "";
                this.newNote.status = "Open";
                this.newNote.requestType = "";
                this.newNote.communicationType = "";
                this.newNote.shouldFollowUp = false;
                this.newNote.followUpDate = toISOLocal(
                    new Date(moment()),
                ).substr(0, 10);

                this.load();
            } catch (e) {
                this.processing = false;
            }
        },
        openDeleteNoteDialog(note) {
            this.noteToDelete = note;
            this.deleteNoteDialog = true;
        },
        async deleteNote() {
            const note = this.noteToDelete;

            try {
                const today = moment().format("YYYY-MM-DD HH:mm:ss");
                this.processing = true;

                await this.$http.post("api/note/delete", {
                    id: note.id,
                    type: this.type,
                    date: note.date,
                    note1: note.note1,
                    byUser: note.byUser,
                    accountID: this.accountID,
                    studentID: this.studentID,
                    typeID: this.typeID,
                    lastUpdated: today,
                    updatedBy: this.$store.state.authentication.user,
                });
                this.deleteNoteDialog = false;
                this.noteToDelete = "";
                await this.load();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.note-button-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    font-size: 12px;
}
.notes-card .v-card--material__header.v-card {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
.hide-header .v-card--material__header {
    display: none !important;
}
.hide-header {
    margin-bottom: 0px !important;
    margin-top: 4px !important;
}
</style>
